export default __webpack_public_path__ + "a257db3a524bd68c3b848ebee4902be6.svg";